export const classes = {
  card: 'w-full flex justify-between items-start gap-2 px-6 py-4 shrink-0 bg-gradient-to-br from-white from-30% dark:bg-none dark:bg-white/[0.04]',
  serviceType: 'size-14 mt-1',
  serviceTypeIcon: 'size-12',
  infoWrapper: 'flex gap-4',
  nameWrapper: 'flex items-center gap-4 mb-1',
  name: 'font-bold text-xl text-grey-8 dark:text-mauve-1',
  status: 'py-1',
  description: 'mt-2 text-sm text-grey-7 dark:text-mauve-2 font-normal',
  projectType: 'text-base text-grey-7 dark:text-mauve-2 font-normal',
  leadButton: 'cursor-pointer',
  controls: 'flex items-center gap-1',
  details: 'flex gap-2',
  closeIcon: 'text-taupe-2 dark:text-mauve-2',
};
